<iframe class="frame" [src]="htmlData | sanitize" frameborder="0">
</iframe>
<div *ngIf="ref" class="d-flex justify-content-center footer">
    <button class="btn btn-md btn-default" *ngIf="closeBtnText" (click)="cancel()">{{closeBtnText}}</button>
    <button class="btn btn-md btn-info" *ngIf="okText" (click)="ok()">{{okText}}</button>
    <button class="btn btn-md btn-danger" *ngIf="cancelText" (click)="cancel()">{{cancelText}}</button>
</div>
